import { FC } from 'react';
import { useTranslation } from '@packages/utils';
import { Alert } from 'components/Base/Alert';
import { EAttendanceState } from 'data/types/registrants.types';
import { TAttendanceBannerProps } from './AttendanceBanner.types';

const AttendanceBanner: FC<TAttendanceBannerProps> = ({
  attendanceState,
  attendanceOpensAt,
  attendanceClosesAt,
  textKeyPrefix,
}) => {
  const { t } = useTranslation();

  if (attendanceState === EAttendanceState.NOT_YET_OPEN) {
    return (
      <Alert
        type="info"
        message={t(`${textKeyPrefix}.NOT_YET_OPEN_WARNING`, {
          when: attendanceOpensAt,
        })}
        data-testid="attendance-banner-not-yet-open"
        style={{ marginBottom: 12 }}
      />
    );
  }

  if (attendanceState === EAttendanceState.CLOSED) {
    return (
      <Alert
        type="warning"
        message={t(`${textKeyPrefix}.EXPIRED_WARNING`, {
          when: attendanceClosesAt,
        })}
        data-testid="attendance-banner-closed"
        style={{ marginBottom: 12 }}
      />
    );
  }

  return null;
};

export default AttendanceBanner;
